import { render, staticRenderFns } from "./PropertyOwnerEdit.vue?vue&type=template&id=3ffa8ae0&"
import script from "./PropertyOwnerEdit.vue?vue&type=script&lang=js&"
export * from "./PropertyOwnerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports